export default __webpack_public_path__ + "static/media/OnsPlek.435f3f32.jpg";